import { Select } from "@/ui";
import { parseTheme, setTheme, THEME_OPTIONS, useTheme } from "./theme";

/** Compact theme picker for the app header: System / Dark / Light. */
export function ThemeToggle() {
  const theme = useTheme();
  return (
    <Select
      aria-label="Colour theme"
      size="sm"
      fieldClassName="app-theme"
      value={theme}
      onChange={(e) => setTheme(parseTheme(e.target.value))}
      options={THEME_OPTIONS}
    />
  );
}
